import React from 'react'
import HeroSection from '../Components/HeroSection.js';
import '../App.css';
import Cards from '../Components/Cards.js';


export default function Home() {
    return (
        <div>
            <HeroSection />
            <Cards />
        </div>
    )
}
 